import {forwardRef, useEffect, useState} from 'react';
import {theme} from '../../theme';
import {Tooltip} from '../../tooltip';
import {Input, InputProps} from '../input/Input';
import {RedAsterisk} from '../redAsterisk/RedAsterisk';
import {InputLabel, StyledInputWithLabel, StyledTooltipIcon} from './styled';
import {ValidationType} from "../../../../types/ValidationType";

export interface InputWithLabelProps extends InputProps {
  label: React.ReactNode;
  labelTooltip?: React.ReactNode;
}

export const InputWithLabel: React.FC<InputWithLabelProps> = forwardRef(
  ({ label, labelTooltip, width, ...props }, ref) => {
    const [filledInput, setFilledInput] = useState(false);

    useEffect(() => {
      setFilledInput(!!(props.defaultValue && props.defaultValue !== ''));
    }, [props.defaultValue]);

    const handleFilledInput = (value: any) => {
      setFilledInput(!!value);
    };

    return (
      <StyledInputWithLabel width={width} filled={filledInput}>
        <InputLabel
          disabled={props.disabled}
          readOnly={props.readOnly}
          filled={filledInput}>
          {label}
          {props.required && <RedAsterisk />}
          {labelTooltip && (
            <Tooltip
              placement="topRight"
              title={labelTooltip}
              color={theme.colors.primaryK10}>
              <StyledTooltipIcon />
            </Tooltip>
          )}
        </InputLabel>
        <Input {...props} validators={[...props.validators || [], ValidationType.XSS]} onFilledInput={handleFilledInput} />
      </StyledInputWithLabel>
    );
  },
);
